import {t} from 'i18next'
import {SalutationCt, UserAccountType} from '../model/enums/enums'

/**
 *
 * @param {UserAccountType | undefined} accountType
 * @param {SalutationCt | undefined} salutation
 * @returns {string}
 */
export const getUserAccountTitleString = (
  accountType: UserAccountType | undefined,
  salutation: SalutationCt | undefined
): string => {
  if (!accountType) {
    return ''
  }

  let languageKey = ''

  switch (accountType) {
    case UserAccountType.Apprentice:
      languageKey = 'apprentice'
      break
    case UserAccountType.Praxisbildner:
      languageKey = 'ausbilder'
      break
    case UserAccountType.Berufsbildner:
      languageKey = 'berufsbildner'
      break
    case UserAccountType.Admin:
      languageKey = 'admin'
      break
    case UserAccountType.NoAccount:
      return ''
    default:
      console.warn('provided user account type is unknown.')
      return ''
  }

  switch (salutation) {
    case SalutationCt.Ms:
      languageKey = languageKey + '.female'
      break
    case SalutationCt.Mr:
      languageKey = languageKey + '.male'
      break
    default:
      languageKey = languageKey + '.neutral'
  }
  return t<string>(`core.${languageKey}`)
}

export const getAccountTypeColor = (
  accountType: UserAccountType | undefined
) => {
  switch (accountType) {
    case UserAccountType.Apprentice:
      return 'light-blue'
    case UserAccountType.Praxisbildner:
      return 'dark-green'
    case UserAccountType.Berufsbildner:
      return 'light-orange'
    case UserAccountType.Admin:
      return 'light-red'
    default:
      return ''
  }
}